export default {
  addMoreSeatsTitle: 'Add more users seats to invite additional users',
  addMoreSeatsDescription:
    'To invite an additional user you need to upgrade your plan.',
  addSeats: 'Add users seats',
  cancel: 'Cancel',
};
